// extracted by mini-css-extract-plugin
export default {"actionsButton":"styles_actionsButton__eZ38n","actionsMenu":"styles_actionsMenu__6DZTa","actionsItem":"styles_actionsItem__3DOG3"};